import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo-text.png';
import _imports_1 from '@/assets/icon_7.png';
import _imports_2 from '@/assets/expert-h.png';
const _withScopeId = n => (_pushScopeId("data-v-3fbc0d1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "preview",
  ref: "listRef"
};
const _hoisted_2 = {
  key: 0,
  class: "content",
  id: "preview-content"
};
const _hoisted_3 = {
  class: "logo-box center-flex-left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1));
const _hoisted_5 = {
  class: "title-desc"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = {
  key: 0,
  class: "list-view"
};
const _hoisted_9 = {
  class: "title__item"
};
const _hoisted_10 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_11 = {
  key: 0,
  class: "item-content border"
};
const _hoisted_12 = {
  key: 1,
  class: "item-content border"
};
const _hoisted_13 = {
  key: 2,
  class: "item-content"
};
const _hoisted_14 = {
  key: 3,
  class: "item-content"
};
const _hoisted_15 = {
  key: 4,
  class: "item-content"
};
const _hoisted_16 = {
  class: "my-van-area"
};
const _hoisted_17 = {
  key: 5,
  class: "item-content"
};
const _hoisted_18 = {
  class: "my-van-area"
};
const _hoisted_19 = {
  key: 6,
  class: "item-content"
};
const _hoisted_20 = {
  key: 1,
  style: {
    "margin-top": "100px",
    "padding": "15px 0",
    "text-align": "center"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "#999"
  }
}, "您已提交问卷，无需重复提交噢！", -1));
const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = {
  class: "expert-pop"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expert-title"
}, "选择带教专家", -1));
const _hoisted_26 = {
  class: "expert-list"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "center-flex-left"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_30 = {
  class: "name"
};
const _hoisted_31 = {
  class: "desc"
};
import { Toast, Dialog } from "vant";
import { momentClient } from "@/utils/axios";
import { gupaoEduAuth } from "@/utils/util";
import { LOGINTOKEN } from "@/constants/common";
import cookies from "js-cookie";
import { useRoute, useRouter } from "vue-router";
import { ref, computed, reactive, onMounted } from "vue";
import { areaList } from "@vant/area-data";
import { getPlatform } from "@/utils/util";
import dayjs from "dayjs";
import uploadFileItem from "./components/upload-file-item.vue";
import uploadMediaItem from "./components/upload-media-item.vue";
import paths from "@/utils/paths";
// vant 支持PC端鼠标滚动事
import "@vant/touch-emulator";
import "vant/es/toast/style";
export default /*#__PURE__*/_defineComponent({
  __name: 'test',
  setup(__props) {
    const detail = ref({
      itemList: [],
      name: "",
      intor: ""
    });
    const state = reactive({
      showRequired: false,
      alertItem: {},
      minDate: new Date(1970, 0, 1)
    });
    // 专家列表
    const expertList = ref([{
      name: "冯导师",
      desc: "【学术背景】麻省理工学院，人工智能与机器视觉专业，博士 【主要研究方向】 深度学习架构与算法：专注于创新的神经网络架构，如变换器（Transformers）、卷积神经网络（CNNs）和递归神经网络（RNNs）在视觉和文本数据中的应用。 计算机视觉：研究图像识别、目标检测和分割、3D视觉重建以及运动分析。 自然语言处理（NLP）：涉及语言模型、文本生成、情感分析和语义理解。 增强学习和多智能体系统：探索智能体在复杂环境中的决策和学习策略。 边缘计算和物联网（IoT）应用：研究机器学习算法在资源受限环境中的优化和部署。 【发表论文】： 共发表论文7篇，包括在高影响力的会议如CVPR、ICCV、ECCV、NeurIPS、ICLR和期刊如JMLR、TPAMI中的论文。 研究涉及最新的机器学习方法和计算机视觉应用。 【可指导方向】： 视觉和语言融合：结合图像识别与NLP技术，专注于图像字幕、视觉问答等跨领域研究。 元学习和迁移学习：研究在不同任务和领域之间迁移和适应学习策略的方法。 自适应和可解释的AI系统：探讨如何构建灵活适应环境变化且对人类用户更加透明和可解释的智能系统。"
    }, {
      name: "D老师",
      desc: "海外Ai-code Top5实验室担任 doctoral researcher, 主持过CMU, Oxford在内的多项AI项目。 主要研究方向：多模态, 大语言模型, NLP, AI-code, 智能社区自治。 指导顶会中稿研究方向： image segmentation, medical report generation, 3D motion generation, multi-model dialogue generation, video understanding and comment generation等，涵盖CV，NLP，多模态等多个课题方向，中稿论文包括但不限于ACM MM， CIKM， AAAI等等。 具体研究方向： 多模态对话问答,视频评论生成/回复, code生成, code copilot, 代码自动化修复, 大语言模型的domain adaption, framework等等. 目前除了AI 理论推理, 其他方向即可带.在顶级国际会议及期刊ASE, EMSE, AAAI, ICLR, TOSEM等发表论文15+篇。担任SOSP, ACL, EMNLP, MSR, ICSE, ICSME 等PC或审稿人。 正主持一项欧盟ERC的基金."
    }, {
      name: "Edward老师",
      desc: "国内Top-2计算机博士，拥有多年海内外顶尖AI科技公司和院所的研究经历，并担任重点科研项目负责人。研究方向为计算机视觉，自然语言处理。主要研究内容涉及3D视觉，数据压缩生成，目标检测，语义分割，生成式模型，多视图几何，扩散模型，AIGC，通用视觉模型，多模态学习。对AI整体发展趋势，模型训练到部署有丰富的实战经验。在顶尖国际会议和期刊ICML，AAAI，ICCV，TMM发表论文7篇，并担任会议审稿人。"
    }]);
    let show = ref(false);
    const route = useRoute();
    const router = useRouter();
    let currentOriginUrl = "";
    let currentSearchData = "";
    let questionId = "";
    const surveyId = computed(() => route.params.id);
    const itemList = computed(() => detail.value.itemList || []);
    const isPC = computed(() => getPlatform().isPC);
    onMounted(async () => {
      window.addEventListener("message", event => {
        try {
          if (typeof event.data !== 'string') return;
          const data = JSON.parse(event.data);
          const {
            parames
          } = data || {};
          const {
            originUrl = "",
            searchData = "",
            id
          } = parames || {};
          currentOriginUrl = decodeURIComponent(originUrl);
          currentSearchData = decodeURIComponent(searchData);
          questionId = id;
        } catch (error) {
          console.log(error);
        }
      }, false);
      const {
        selfOriginUrl = "",
        selfSearchData = "",
        selfQuestionId = ""
      } = route.query || {};
      if (selfOriginUrl) {
        currentOriginUrl = decodeURIComponent(selfOriginUrl);
        currentSearchData = decodeURIComponent(selfSearchData);
        questionId = selfQuestionId;
      }
    });
    // 是否为必选项
    const itemRules = computed(() => item => {
      if (!state.showRequired) return false;else if (item.required && (!item.value || item.value.length == 0)) return true;else return false;
    });
    // 检查是否有必填项为完成
    const checkForm = () => {
      state.showRequired = true;
      const item = itemList.value.find(v => {
        if (v.required && (!v.value || v.value.length == 0)) return true;
        return false;
      });
      return item ? false : true;
    };
    // 导入附件
    const addAttachment = (file, item) => {
      var _file$file;
      const size = file.size || ((_file$file = file.file) === null || _file$file === void 0 ? void 0 : _file$file.size);
      const sizeInt = size || 0;
      // 文件最大不能超过30M
      if (sizeInt / 1024 / 1024 > 30) {
        Toast('文件最大不能超过30M');
        return;
      }
      file.name = file.file.name;
      file.uid = new Date().getTime();
      item.value = file;
    };
    // 删除附件
    const deleteAttachmentItem = item => {
      item.value = null;
    };
    // click
    // 日期选择
    const dateClick = item => {
      state.alertItem = item;
      state.alertItem.showDate = true;
    };
    const onChangePageTitle = (data = {}) => {
      const {
        name = ""
      } = data || {};
      document.title = name;
    };
    const onDateConfirm = v => {
      state.alertItem.value = dayjs(v).format("YYYY-MM-DD");
      state.alertItem.showDate = false;
    };
    // 城市选择
    const cityClick = item => {
      state.alertItem = item;
      state.alertItem.showArea = true;
    };
    const onCityConfirm = v => {
      state.alertItem.value = v.map(vv => vv.name).join("-");
      state.alertItem.showArea = false;
    };
    // 提交
    const commitClick = async () => {
      if (itemList.value.length == 0) {
        Toast("调查问卷错误");
        return;
      }
      if (!checkForm()) {
        Toast("您有必填项未完成");
        return;
      }
      // 检查文件内容是否上传完毕
      let isUploadFinished = true;
      const answerList = itemList.value.map(v => {
        var _v$value$file;
        let {
          options = [],
          value = []
        } = v || {};
        if (value && !Array.isArray(value)) value = [value];
        const allTags = [];
        if (Array.isArray(value)) {
          value.forEach(answer => {
            const selectItem = options.find(item => item.id == answer);
            const {
              tags = []
            } = selectItem || {};
            allTags.push(...tags);
          });
        }
        // 检查文件是否都上传完毕了
        if (v.type == 7) {
          if (!v.value || !v.value.url) isUploadFinished = false;
        }
        // 文件只需要取url字段信息
        const answers = v.type == 7 && v.value ? {
          url: v.value.url || '',
          contentType: v.contentType,
          name: (_v$value$file = v.value.file) === null || _v$value$file === void 0 ? void 0 : _v$value$file.name
        } : v.value;
        return {
          itemId: v.id,
          answers: JSON.stringify(answers),
          tags: JSON.stringify(allTags),
          itemType: v.type,
          subType: v.subType
        };
      });
      // 文件为全部上传完成
      if (!isUploadFinished) {
        Toast("等待文件上传完成后再点击提交");
        return;
      }
      const params = {
        id: surveyId.value,
        answerList: answerList,
        saleUcode: route.query.scode,
        resourceId: route.query.resourceId
      };
      Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      try {
        await commitApi(params);
        Toast.clear();
        if (currentOriginUrl) {
          let searchStr = "";
          let searchData;
          try {
            searchData = JSON.parse(currentSearchData || "{}") || {};
            for (const key in searchData) {
              if (Object.prototype.hasOwnProperty.call(searchData, key)) {
                searchStr += `${key}=${searchData[key]}&`;
              }
            }
            await Dialog.alert({
              title: "提示",
              message: "提交成功"
            });
            window.location.href = `${currentOriginUrl}?isQuestionCallback=1&questionId=${questionId}&${searchStr}`;
            return;
          } catch (error) {
            // console.log(error)
          }
        }
        await Dialog.alert({
          title: "提示",
          message: "提交成功"
        });
        // 显示选择专家 (测试环境问卷id=1053,正式环境问卷id=1046)
        const id = process.env.VUE_APP_IS_DEBUG ? "1053" : "1046";
        if (surveyId.value == id) {
          if (detail.value.jumpLink) {
            showSelectExpert.value = true;
          } else {
            router.push("/survey/finished");
          }
          return;
        }
        if (detail.value.jumpLink) {
          (window.top || window).location.href = detail.value.jumpLink;
        } else {
          router.push("/survey/finished");
        }
      } catch (e) {
        console.error("错误信息", e);
        Toast.fail(e.msg || "提交失败");
      }
    };
    // 马上联系
    const showSelectExpert = ref(false); //显示选择专家
    const activeIndex = ref(-1);
    const contactClick = () => {
      if (activeIndex.value < 0) {
        Toast("请选择老师");
        return;
      }
      if (detail.value.jumpLink) {
        (window.top || window).location.href = detail.value.jumpLink;
      } else {
        Toast.fail("暂未配置跳转链接");
      }
    };
    // 关闭窗口
    const clickClose = () => {
      if (detail.value.jumpLink) {
        (window.top || window).location.href = detail.value.jumpLink;
      }
    };
    // ------- net
    // 获取问卷详情
    const fetchDetailApi = async surveyId => {
      const res = await momentClient.get(paths.moment() + `/ke/survey/question/${surveyId}`);
      if (res.status === 200) {
        if (res.data.code == 0) return res.data;
        return Promise.reject(res.data);
      }
      return Promise.reject({
        ...res,
        msg: res.statusText,
        code: res.status
      });
    };
    // 提交
    const commitApi = async params => {
      const res = await momentClient.post(paths.moment() + `/ke/survey/question/info`, params);
      if (res.status === 200) {
        if (res.data.code == 0) return res.data;
        return Promise.reject(res.data);
      }
      return Promise.reject({
        ...res,
        msg: res.statusText,
        code: res.status
      });
    };
    // 初始化
    const init = async () => {
      // 未登陆去登陆页
      const tk = cookies.get(LOGINTOKEN);
      const {
        fullPath
      } = route;
      const url = `${fullPath}&selfOriginUrl=${encodeURIComponent(currentOriginUrl)}&selfSearchData=${encodeURIComponent(currentSearchData)}&selfQuestionId=${questionId}`;
      if (!tk) gupaoEduAuth(url);
      try {
        // 判断用户是否已填写问卷
        if (route.query.flag) {
          const res = await momentClient.get(paths.moment() + `/ke/survey/question/checkQuestionnaireSubmission/${route.params.id}`);
          if (res.status === 200) {
            if (res.data.code == 0) {
              show.value = res.data.data;
            }
          }
        }
        const res = await fetchDetailApi(surveyId.value);
        onChangePageTitle(res.data);
        detail.value = res.data;
        if (detail.value.itemList) detail.value.itemList = detail.value.itemList.map(v => ({
          ...v,
          value: v.type == 2 ? [] : "",
          showDate: false,
          showArea: false,
          options: v.options ? JSON.parse(v.options) : []
        }));
      } catch (e) {
        console.error(e);
        const {
          msg = ""
        } = e || {};
        Toast.fail(msg || "加载失败");
      }
    };
    init();
    return (_ctx, _cache) => {
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_datetime_picker = _resolveComponent("van-datetime-picker");
      const _component_van_popover = _resolveComponent("van-popover");
      const _component_van_area = _resolveComponent("van-area");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(show) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["header", {
          'header-pc': isPC.value
        }])
      }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(detail.value.slogan ? detail.value.slogan : "更专业的满足你定制化AI需求"), 1)]), _createElementVNode("span", _hoisted_6, _toDisplayString(detail.value.name), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(detail.value.intor), 1)], 2), detail.value.itemList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.customId,
          class: _normalizeClass(["draggable-item", {
            'show-red': itemRules.value(item)
          }])
        }, [_createElementVNode("span", _hoisted_9, [item.required ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(index + 1) + "、" + _toDisplayString(item.title), 1)]), item.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_radio_group, {
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, tt => {
            return _openBlock(), _createBlock(_component_van_radio, {
              key: tt.id,
              name: tt.id,
              "icon-size": "16px",
              "checked-color": "#f18300"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(tt.title), 1)]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : item.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_van_checkbox_group, {
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, tt => {
            return _openBlock(), _createBlock(_component_van_checkbox, {
              key: tt.id,
              name: tt.id,
              "icon-size": "16px",
              shape: "square",
              "checked-color": "#f18300"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(tt.title), 1)]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])) : item.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_field, {
          class: "border",
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event,
          placeholder: item.placeholder,
          type: "textarea",
          rows: 3,
          maxlength: item.maxLength == null || item.maxLength == 0 ? 9999 : item.maxLength,
          "show-word-limit": item.maxLength > 0
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "maxlength", "show-word-limit"])])) : item.type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_field, {
          class: "border",
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event,
          placeholder: item.placeholder,
          maxlength: item.maxLength == null || item.maxLength == 0 ? 9999 : item.maxLength
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "maxlength"])])) : item.type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [isPC.value ? (_openBlock(), _createBlock(_component_van_popover, {
          key: 0,
          show: item.showDate,
          "onUpdate:show": $event => item.showDate = $event,
          onOpen: $event => dateClick(item)
        }, {
          reference: _withCtx(() => [_createVNode(_component_van_field, {
            class: "border",
            modelValue: item.value,
            "onUpdate:modelValue": $event => item.value = $event,
            placeholder: item.placeholder,
            readonly: "",
            "right-icon": "calendar-o"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_van_datetime_picker, {
            type: "date",
            title: "选择年月日",
            "min-date": state.minDate,
            onCancel: $event => item.showDate = false,
            onConfirm: onDateConfirm
          }, null, 8, ["min-date", "onCancel"])])]),
          _: 2
        }, 1032, ["show", "onUpdate:show", "onOpen"])) : (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          class: "border",
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event,
          placeholder: item.placeholder,
          readonly: "",
          "right-icon": "calendar-o",
          onClick: $event => dateClick(item)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onClick"]))])) : item.type == 6 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [isPC.value ? (_openBlock(), _createBlock(_component_van_popover, {
          key: 0,
          show: item.showArea,
          "onUpdate:show": $event => item.showArea = $event,
          onOpen: $event => cityClick(item)
        }, {
          reference: _withCtx(() => [_createVNode(_component_van_field, {
            class: "border",
            modelValue: item.value,
            "onUpdate:modelValue": $event => item.value = $event,
            placeholder: item.placeholder,
            readonly: "",
            "is-link": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_van_area, {
            "columns-num": 2,
            "area-list": _unref(areaList),
            onConfirm: onCityConfirm,
            onCancel: _cache[0] || (_cache[0] = $event => state.alertItem.showArea = false)
          }, null, 8, ["area-list"])])]),
          _: 2
        }, 1032, ["show", "onUpdate:show", "onOpen"])) : (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          class: "border",
          modelValue: item.value,
          "onUpdate:modelValue": $event => item.value = $event,
          placeholder: item.placeholder,
          readonly: "",
          "is-link": "",
          onClick: $event => cityClick(item)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onClick"]))])) : item.type == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [!item.value ? (_openBlock(), _createBlock(_component_van_uploader, {
          key: 0,
          "after-read": file => {
            addAttachment(file, item);
          },
          accept: "*"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["upload-item", {
              'upload-item-media': item.contentType == 2 || item.contentType == 3
            }])
          }, [_createVNode(_component_van_icon, {
            name: "plus"
          }), _createElementVNode("span", null, _toDisplayString(item.placeholder), 1)], 2)]),
          _: 2
        }, 1032, ["after-read"])) : _createCommentVNode("", true), item.value && item.contentType == 1 ? (_openBlock(), _createBlock(uploadFileItem, {
          key: 1,
          file: item.value,
          onDelete: $event => deleteAttachmentItem(item)
        }, null, 8, ["file", "onDelete"])) : _createCommentVNode("", true), item.value && (item.contentType == 2 || item.contentType == 3) ? (_openBlock(), _createBlock(uploadMediaItem, {
          key: 2,
          "just-media-type": item.contentType == 2 ? 1 : 2,
          file: item.value,
          onDelete: $event => deleteAttachmentItem(item)
        }, null, 8, ["just-media-type", "file", "onDelete"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "footer"
      }, [_createElementVNode("div", {
        class: "commit-btn",
        onClick: commitClick
      }, "提 交")])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23)), !isPC.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createVNode(_component_van_popup, {
        show: state.alertItem.showArea,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => state.alertItem.showArea = $event),
        position: "bottom",
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_area, {
          "columns-num": 2,
          "area-list": _unref(areaList),
          onConfirm: onCityConfirm,
          onCancel: _cache[1] || (_cache[1] = $event => state.alertItem.showArea = false)
        }, null, 8, ["area-list"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: state.alertItem.showDate,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => state.alertItem.showDate = $event),
        position: "bottom",
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_datetime_picker, {
          type: "date",
          title: "选择年月日",
          "min-date": state.minDate,
          onCancel: _cache[3] || (_cache[3] = $event => state.alertItem.showDate = false),
          onConfirm: onDateConfirm
        }, null, 8, ["min-date"])]),
        _: 1
      }, 8, ["show"])], 64)) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
        show: showSelectExpert.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => showSelectExpert.value = $event),
        "lock-scroll": false,
        closeable: "",
        round: "",
        onClickCloseIcon: clickClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expertList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", index == activeIndex.value ? 'active' : '']),
            key: index,
            onClick: $event => activeIndex.value = index
          }, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_31, _toDisplayString(item.desc), 1)], 10, _hoisted_27);
        }), 128))]), _createElementVNode("div", {
          class: "footer mb20"
        }, [_createElementVNode("div", {
          class: "commit-btn",
          onClick: contactClick
        }, "马上联系")])])]),
        _: 1
      }, 8, ["show"])], 512);
    };
  }
});